<template>
  <AppContainer v-if="navigation" class="btns-container ms-0 ps-0 mb-4">
    <div class="flex justify-end gap-3">
      <AppBtn class="btn mt-0" :icon="`mdi:chevron-${getDirection('back')}`" @click="carousel?.prev" still />
      <AppBtn class="btn mt-0" :icon="`mdi:chevron-${getDirection('next')}`" @click="carousel?.next" still />
    </div>
  </AppContainer>
  <Carousel
    v-bind="$attrs" 
    ref="carousel"
    :dir="rtl ? 'rtl' : 'ltr'"
    :class="{ end, elevated }"
    data-allow-mismatch
  >
    <slot />
    <template v-if="pagination" #addons>
      <Pagination class="pagination" />
    </template>
  </Carousel>
</template>

<script setup lang="ts">
import 'vue3-carousel/dist/carousel.css';
import { Carousel, type CarouselMethods, Pagination } from 'vue3-carousel';

defineOptions({ inheritAttrs: false });

defineProps<{
  navigation?: boolean;
  pagination?: boolean;
  end?: boolean;
  elevated?: boolean;
}>();

const carousel = useTemplateRef<CarouselMethods>('carousel');
const { getDirection } = useFormat();
const { rtl } = useLocalization();

defineExpose({
  slideTo: (i: number) => carousel.value?.slideTo(i),
  next: () => carousel.value?.next(),
  prev: () => carousel.value?.prev()
});
</script>

<style scoped lang="scss">
.pagination {
  bottom: calc(-1 * var(--space-6));
}
:deep(.carousel__pagination-button::after) {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: rgb(29, 67, 252, 0.3);
}
:deep(.carousel__pagination-button--active::after) {
  background-color: rgb(29, 67, 252, 1);
}
.btns-container .btn {
  background-color: rgb(var(--v-theme-primary));
  color: #fff;
  width: var(--space-6) !important;
  height: var(--space-6) !important;
  border-radius: 8px;
}
.btns-container .btn:hover {
  box-shadow: none !important;
}
.elevated {
  margin-inline-start: calc(-1 * var(--space-5));

  :deep(.carousel__slide) {
    padding: var(--space-5);
  }
}

@media (min-width: 1201px) {
  .btns-container {
    margin-inline-end: var(--space-5) !important;
  }
}

@media (min-width: 851px) {
  .end {
    :deep(.carousel__slide) {
      justify-content: flex-start;
    }
  }
}

@media (max-width: 850px) {
  .elevated {
    margin-inline-end: calc(-1 * var(--space-5));
  }
  .btns-container {
    margin-bottom: var(--space-2) !important;
  }
  .btns-container .flex {
    margin-inline-end: var(--space-4);
  }
}
</style>